import {
  GAME_W,
  TURRET_FIRE_INTERVAL,
  TURRET_GUN_LENGTH,
  TURRET_CENTER_X,
  TURRET_CENTER_Y,
  BULLET_SPEED,
} from "./data";
import { landscape } from "./terrain";
import { copter } from "./copter";
import { bullets } from "./entities";
import { camera } from "./camera";
import { Asset } from "assets.gen";
import { playSoundAt } from "audio";
import { cos, sin } from "core/math";
import { dt } from "lib/loop";

export const TURRET_TOWER_H = 8;

export interface Turret {
  x: number;
  y: number;
  cx: number;
  cy: number;
  active: boolean;
  _fireTime: number;
  angle: number;
}

export const turrets: Turret[] = [];

export function spawnTurret(): void {
  const x = camera.x + GAME_W;
  const { top: topY } = landscape.getPlaceOffsets(x + TURRET_CENTER_X);
  const y = topY - TURRET_TOWER_H * 0.5;
  turrets.push({ x, y, cx: TURRET_CENTER_X, cy: TURRET_CENTER_Y, active: true, _fireTime: 0, angle: 0 });
}

export function updateTurrets(): void {
  for (let i = turrets.length - 1; i >= 0; i--) {
    const t = turrets[i];
    if (!t.active) {
      turrets.splice(i, 1);
      continue;
    }

    const { top: topY } = landscape.getPlaceOffsets(t.x + t.cx);
    t.y = topY - TURRET_TOWER_H * 0.5;

    if (t.x + 20 < camera.x) {
      turrets.splice(i, 1);
      continue;
    }

    t._fireTime += dt;
    if (t._fireTime >= TURRET_FIRE_INTERVAL) {
      t._fireTime -= TURRET_FIRE_INTERVAL;
      shootTurret(t);
    }

    t.angle = Math.atan2(copter.centre.y - (t.y + t.cy), copter.centre.x - (t.x + t.cx));
  }
}

function shootTurret(t: Turret): void {
  if (t.y > copter.centre.y) return;
  if (t.x > copter.centre.x) return;

  playSoundAt(Asset.sfx_turret_shoot, camera.worldToScreenX(t.x), GAME_W, 1);
  const launchDir = Math.atan2(copter.centre.y - (t.y + t.cy), copter.centre.x - (t.x + t.cx));
  const startX = t.x + t.cx + TURRET_GUN_LENGTH * cos(launchDir);
  const startY = t.y + t.cy + TURRET_GUN_LENGTH * sin(launchDir);

  bullets.push({
    x: startX,
    y: startY,
    _vx: BULLET_SPEED * cos(launchDir),
    _vy: BULLET_SPEED * sin(launchDir),
    _startX: startX,
    _startY: startY,
    _dx: 0,
    _dy: 0,
    active: true,
  });
}

export function resetTurrets(): void {
  turrets.length = 0;
}
